import axios from "../../lib/axiosInstance";

export const fetchAllInvoices = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.role) params.append("role", filters.role);
  if (filters.page != null) params.append("page", filters.page);
  if (filters.limit != null) params.append("limit", filters.limit);
  if (filters.search?.trim()) params.append("search", filters.search.trim());

  if (filters.id) params.append("id", filters.id);
  if (filters?.status !== undefined || filters?.status?.value)
    params.append("status", filters.status);
  if (filters?.engineer !== undefined || filters?.engineer?.value)
    params.append("engineer", filters.engineer);
  if (filters?.customer !== undefined || filters?.customer?.value)
    params.append("customer", filters.customer);
  if (filters?.generatedBy !== undefined || filters?.generatedBy?.value)
    params.append("generatedBy", filters.generatedBy);
  if (filters?.reviewedBy !== undefined || filters?.reviewedBy?.value)
    params.append("reviewedBy", filters.reviewedBy);
  if (filters?.sendBy !== undefined || filters?.sendBy?.value)
    params.append("sendBy", filters.sendBy);
  if (filters?.paidBy !== undefined || filters?.paidBy?.value)
    params.append("paidBy", filters.paidBy);
  if (filters?.tax) params.append("taxType", filters.tax);

  if (filters.creationStartDate)
    params.append("creationStartDate", filters.creationStartDate);
  if (filters.creationEndDate)
    params.append("creationEndDate", filters.creationEndDate);
  if (filters.dueStartDate) params.append("dueStartDate", filters.dueStartDate);
  if (filters.dueEndDate) params.append("dueEndDate", filters.dueEndDate);

  if (filters.clientId) params.append("clientId", filters.clientId);

  const url = `/invoices${params.toString() ? `?${params.toString()}` : ""}`;

  const response = await axios.get(url);
  return response.data;
};

export const fetchAllEngineerInvoices = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.role) params.append("role", filters.role);
  if (filters.page != null) params.append("page", filters.page);
  if (filters.limit != null) params.append("limit", filters.limit);
  if (filters.search?.trim()) params.append("search", filters.search.trim());

  if (filters.id) params.append("id", filters.id);
  if (filters?.status !== undefined || filters?.status?.value)
    params.append("status", filters.status);
  if (filters?.engineer !== undefined || filters?.engineer?.value)
    params.append("engineer", filters.engineer);
  if (filters?.customer !== undefined || filters?.customer?.value)
    params.append("customer", filters.customer);
  if (filters?.generatedBy !== undefined || filters?.generatedBy?.value)
    params.append("generatedBy", filters.generatedBy);
  if (filters?.reviewedBy !== undefined || filters?.reviewedBy?.value)
    params.append("reviewedBy", filters.reviewedBy);
  if (filters?.sendBy !== undefined || filters?.sendBy?.value)
    params.append("sendBy", filters.sendBy);
  if (filters?.paidBy !== undefined || filters?.paidBy?.value)
    params.append("paidBy", filters.paidBy);
  if (filters?.tax) params.append("taxType", filters.tax);

  if (filters.creationStartDate)
    params.append("creationStartDate", filters.creationStartDate);
  if (filters.creationEndDate)
    params.append("creationEndDate", filters.creationEndDate);
  if (filters.dueStartDate) params.append("dueStartDate", filters.dueStartDate);
  if (filters.dueEndDate) params.append("dueEndDate", filters.dueEndDate);

  if (filters.clientId) params.append("clientId", filters.clientId);

  const url = `/invoices/engineer${
    params.toString() ? `?${params.toString()}` : ""
  }`;

  const response = await axios.get(url);
  return response.data;
};

export const fetchInvoiceStatusCounts = async (filters = {}) => {
  const params = new URLSearchParams();

  if (filters.role) params.append("role", filters.role);
  if (filters.search?.trim()) params.append("search", filters.search.trim());

  if (filters.id) params.append("id", filters.id);

  if (filters.status !== undefined) params.append("status", filters.status);
  if (filters.customer !== undefined)
    params.append("customer", filters.customer);
  if (filters.engineer !== undefined)
    params.append("engineer", filters.engineer);
  if (filters.generatedBy !== undefined)
    params.append("generatedBy", filters.generatedBy);
  if (filters.reviewedBy !== undefined)
    params.append("reviewedBy", filters.reviewedBy);
  if (filters.sendBy !== undefined) params.append("sendBy", filters.sendBy);
  if (filters.paidBy !== undefined) params.append("paidBy", filters.paidBy);

  if (filters.tax) params.append("taxType", filters.tax);

  if (filters.creationStartDate)
    params.append("creationStartDate", filters.creationStartDate);
  if (filters.creationEndDate)
    params.append("creationEndDate", filters.creationEndDate);
  if (filters.dueStartDate) params.append("dueStartDate", filters.dueStartDate);
  if (filters.dueEndDate) params.append("dueEndDate", filters.dueEndDate);

  if (filters.clientId) params.append("clientId", filters.clientId);

  const url = `/invoices/statusCount${
    params.toString() ? `?${params.toString()}` : ""
  }`;

  const response = await axios.get(url);
  return response.data;
};

export function createInvoice(payload) {
  return axios.post(`/invoices`, payload).then((res) => res.data);
}

export function createEngineerInvoice(payload) {
  return axios.post(`/invoices/engineer`, payload).then((res) => res.data);
}

export const fetchAllWorkOrderByInvoice = async (id, role) => {
  const params = new URLSearchParams();
  params.append("role", role);

  return axios
    .get(`/invoices/${id}?${params.toString()}`)
    .then((res) => res.data);
};

export const fetchAllEngineerWorkOrderByInvoice = async (id, role) => {
  const params = new URLSearchParams();
  params.append("role", role);

  return axios
    .get(`/invoices/engineer/${id}?${params.toString()}`)
    .then((res) => res.data);
};

export const fetchInvoiceDetails = async (id) => {
  return axios.get(`/invoices/details/${id}`).then((res) => res.data);
};

export const fetchEngineerInvoiceDetails = async (id) => {
  return axios.get(`/invoices/engineer/details/${id}`).then((res) => res.data);
};

export function deleteInvoice(id) {
  return axios.delete(`/invoices/${id}`).then((res) => res.data);
}

export function deleteEngineerInvoice(id) {
  return axios.delete(`/invoices/engineer/${id}`).then((res) => res.data);
}

export function verifyCustomerInvoice(id, payload) {
  const formData = new FormData();

  formData.append("id", id);

  formData.append("status", payload.status);

  if (payload.file) {
    formData.append("file", payload.file);
  }

  if (payload.toEmail) {
    formData.append("toEmail", payload.toEmail);
  }
  if (payload.ccEmails) {
    formData.append("toEmail", payload.ccEmails);
  }

  return axios
    .patch(`/invoices/verify/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => res.data);
}

export function verifyEngineerInvoice(id, payload) {
  const formData = new FormData();

  formData.append("id", id);

  formData.append("status", payload.status);

  if (payload.file) {
    formData.append("file", payload.file);
  }

  if (payload.toEmail) {
    formData.append("toEmail", payload.toEmail);
  }
  if (payload.ccEmails) {
    formData.append("toEmail", payload.ccEmails);
  }

  return axios
    .patch(`/invoices/engineer/verify/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => res.data);
}

export function sendCustomerInvoice(id, payload) {
  const formData = new FormData();

  formData.append("id", id);

  formData.append("status", payload.status);

  if (payload.file) {
    formData.append("file", payload.file);
  }

  if (payload.toEmail) {
    formData.append("toEmail", payload.toEmail);
  }
  if (payload.ccEmails) {
    formData.append("toEmail", payload.ccEmails);
  }
  if (payload.skipEmail !== undefined) {
    formData.append("skipEmail", String(payload.skipEmail));
  }

  return axios
    .patch(`/invoices/send/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => res.data);
}

export function sendEngineerInvoice(id, payload) {
  const formData = new FormData();

  formData.append("id", id);

  formData.append("status", payload.status);

  if (payload.file) {
    formData.append("file", payload.file);
  }

  if (payload.toEmail) {
    formData.append("toEmail", payload.toEmail);
  }
  if (payload.ccEmails) {
    formData.append("toEmail", payload.ccEmails);
  }
  if (payload.skipEmail !== undefined) {
    formData.append("skipEmail", String(payload.skipEmail));
  }

  return axios
    .patch(`/invoices/engineer/send/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => res.data);
}

export function paidCustomerInvoice(id, payload) {
  const formData = new FormData();

  formData.append("id", id);

  formData.append("status", payload.status);

  if (payload.file) {
    formData.append("file", payload.file);
  }

  if (payload.toEmail) {
    formData.append("toEmail", payload.toEmail);
  }
  if (payload.ccEmails) {
    formData.append("toEmail", payload.ccEmails);
  }

  return axios
    .patch(`/invoices/paid/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => res.data);
}

export function paidEngineerInvoice(id, payload) {
  const formData = new FormData();

  formData.append("id", id);

  formData.append("status", payload.status);

  if (payload.file) {
    formData.append("file", payload.file);
  }

  if (payload.toEmail) {
    formData.append("toEmail", payload.toEmail);
  }
  if (payload.ccEmails) {
    formData.append("toEmail", payload.ccEmails);
  }

  return axios
    .patch(`/invoices/engineer/paid/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => res.data);
}

export function deleteInvoiceWorkOrder(payload) {
  return axios.post(`/invoices/workOrder`, payload).then((res) => res.data);
}

export function deleteEngineerInvoiceWorkOrder(payload) {
  return axios
    .post(`/invoices/engineer/workOrder`, payload)
    .then((res) => res.data);
}

// payload: { invoiceId, workOrderIds: [] }
export function addInvoiceWorkOrders(payload) {
  return axios
    .post(`/invoices/workOrder/add`, payload)
    .then((res) => res.data);
}

export function addEngineerInvoiceWorkOrders(payload) {
  return axios
    .post(`/invoices/engineer/workOrder/add`, payload)
    .then((res) => res.data);
}

// Approved work orders eligible for this invoice — one endpoint for both
// invoice types, since the invoice's own role decides what qualifies.
export const fetchAvailableWorkOrdersForInvoice = async (invoiceId) => {
  return axios
    .get(`/invoices/${invoiceId}/availableWorkOrders`)
    .then((res) => res.data);
};

export function downloadInvoice(invoiceId) {
  return axios
    .get(`/invoices/download/${invoiceId}`, {
      responseType: "blob",
    })
    .then((res) => res.data);
}

export function downloadInvoiceProof(invoiceId) {
  return axios
    .get(`/invoices/download/proof/${invoiceId}`, {
      responseType: "blob",
    })
    .then((res) => res.data);
}

export function updateInvoiceNote(payload) {
  const { id, ...rest } = payload;
  return axios.patch(`/invoices/comment/${id}`, rest).then((res) => res.data);
}
